import {
  AppBar,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSTextField, {
  CurrencyType,
  TextType,
} from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const VyaparPos: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const [tabValue, setTabValue] = React.useState(0);
  const navigate = useNavigate()
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleCancel = () =>{
    navigate("/")
  }
  return (
    <>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          {/* Tabs aligned left */}
          <Grid sx={{ flexGrow: 1 }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="#1" />
              <Tab label="+ New Bill [Ctrl+T]" />
            </Tabs>
          </Grid>

          {/* Icons aligned right */}
          <Grid>
            <IconButton size="small" color="inherit">
              <WSIcons.MinimizeIcon />
            </IconButton>
            <IconButton size="small" color="inherit">
              <WSIcons.SettingsIcon />
            </IconButton>
            <IconButton size="small" color="inherit">
              <WSIcons.CloseIcon onClick={handleCancel}/>
            </IconButton>
          </Grid>
        </Toolbar>
      </AppBar>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Scan or search by item code, model no or item name"
                size="small"
                variant="outlined"
                sx={{ backgroundColor: "#FFFF" }}
              />
            </Grid>
            <Grid item xs={12}>
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 500, // Fixed height
                  height: 500, // Ensures table is always the same size
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>ITEM CODE</TableCell>
                      <TableCell>ITEM NAME</TableCell>
                      <TableCell>QTY</TableCell>
                      <TableCell>UNIT</TableCell>
                      <TableCell>PRICE/UNIT($)</TableCell>
                      <TableCell>DISCOUNT($)</TableCell>
                      <TableCell>TAX APPLIED($)</TableCell>
                      <TableCell>TOTAL($)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{/* Empty rows / mapped items */}</TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Change Quantity [F2]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Item Discount [F3]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Remove Item [F4]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Change Unit [F6]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Additional Charges [F8]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Bill Discount [F9]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Loyalty Points [F10]</Button>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="outlined">Remarks [F12]</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} mt={2}>
          <Paper>
            <Grid container spacing={2} p={1}>
              <Grid item xs={12}>
                <Typography variant="body2">
                  Invoice Date: 27/08/2025
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  placeholder="Search for a customer by name, phone number"
                  size="small"
                  variant="outlined"
                  sx={{ backgroundColor: "#FFFF" }}
                />
              </Grid>
            </Grid>
          </Paper>
          <Grid item xs={12}>
            <Paper>
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={8}>
                  <Typography variant="h6">Total $0.000</Typography>
                  <Typography variant="body2">Items: 0, Quantity: 0</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Paper
              sx={{
                height: 350, // Fixed height
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between", // Pushes content to top and bottom
                p: 2,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    rules={{ required: true }}
                    {...register("paymentMode")}
                    id="paymentMode"
                    control={control}
                    label="Payment Mode"
                    name="paymentMode"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Amount Received"}
                    {...register("amountReceived")}
                    id="amountReceived"
                    name="amountReceived"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Dollar}
                    rules={{ required: false }}
                  />
                </Grid>
              </Grid>

              {/* Bottom Typography */}
              <Typography
                variant="body1"
                align="right"
                sx={{ mt: 2, fontWeight: "bold" }}
              >
                Change To Return: $0.00
              </Typography>
            </Paper>
          </Grid>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
              <Button fullWidth variant="contained" color="success">
                Save & Print Bill [Ctrl+P]
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth variant="outlined">
                Other/Credit Payments [Ctrl+M]
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
